var typeCalculator = 'fughe'; // 'fughe' (grout) or 'sigillanti' (sealants)
var groutKConstant;
var packages = [];
var productName = '';
var productId = '';

// Load product data
function loadProduct(f_GoutKConstant, f_Packages, f_ProductName, f_ProductId, f_type) {
  groutKConstant = f_GoutKConstant;
  packages = f_Packages;
  productName = f_ProductName;
  productId = f_ProductId;
  typeCalculator = f_type;
}

// Calculate based on type
function calculate(inputs) {
  if (typeCalculator === 'fughe') {
    // inputs: tileLength, tileWidth, tileThickness, jointWidth, areaToGrout
    const { tileLength, tileWidth, tileThickness, jointWidth, areaToGrout } = inputs;
    if ([tileLength, tileWidth, tileThickness, jointWidth, areaToGrout].some(v => !v || v <= 0)) {
      console.log("Please provide valid positive values for all inputs.");
      return;
    }
    
    let groutNeeded = (tileLength + tileWidth) / (tileLength * tileWidth) * groutKConstant * tileThickness * jointWidth * areaToGrout;
    console.log("test1",groutNeeded)
    groutNeeded = parseFloat(groutNeeded.toFixed(1));
    console.log(`Product: ${productName}`);
    console.log(`Grout needed: ${groutNeeded}`);
    console.log(packages);
    let all_packages = []
    packages.forEach(pkg => {
      let packsNeeded = Math.ceil(groutNeeded / pkg.Volume);
      console.log(`Package ${pkg.Volume} ${pkg.VolumeUnit}: ${packsNeeded} packs needed`);
      all_packages.push(packsNeeded);
    });
    return {groutNeeded, all_packages};
  }
  else if (typeCalculator === 'sigillanti') {
    // inputs: linearMeter, jointWidth, jointDepth
    const { linearMeter, jointWidth, jointDepth } = inputs;
    if ([linearMeter, jointWidth, jointDepth].some(v => !v || v <= 0)) {
      console.log("Please provide valid positive values for all inputs.");
      return;
    }

    packages.forEach(pkg => {
      let linearMeterPerPack;
      if (pkg.VolumeUnit.toLowerCase() === "kg") {
        linearMeterPerPack = pkg.Volume / (((jointWidth * jointDepth * 1000) / 1000000) * pkg.SpecificWeight);
      } else {
        linearMeterPerPack = pkg.Volume / (jointWidth * jointDepth);
      }
      linearMeterPerPack = parseFloat(linearMeterPerPack.toFixed(1));
      let packsNeeded = Math.ceil(linearMeter / linearMeterPerPack);
      console.log(`Product: ${productName}`);
      console.log(`Package ${pkg.Description} covers approx. ${linearMeterPerPack} linear meters`);
      console.log(`Packs needed: ${packsNeeded}`);
    });
  }
  else {
    console.log("Unknown typeCalculator value");
  }
}
